"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailMessageEvent = void 0;
var email_send_message_1 = require("./email-send-message");
Object.defineProperty(exports, "EmailMessageEvent", { enumerable: true, get: function () { return email_send_message_1.EmailMessageEvent; } });
